import { WorldMapButtonGroup } from "@components/world-map/world-map-types";
import { Button, neutral, Tooltip } from "@flat-ui";
import { alpha, Stack } from "@mui/material";

/** Opacity for the button background on hover */
const HOVER_OPACITY = 0.15;

/** Opacity for the button background on active/press */
const ACTIVE_OPACITY = 0.25;

interface Props {
  /** Button groups to be displayed on the map */
  buttonGroups?: WorldMapButtonGroup[];
}

/** Renders action button groups on the top right corner of the map */
export function WorldMapButtons({
  buttonGroups,
}: Props): JSX.Element | undefined {
  if (!buttonGroups || !buttonGroups.length) {
    return;
  }

  return (
    <Stack
      sx={{
        position: "absolute",
        right: 1,
        top: 1,
        zIndex: 1000,
        display: "inline-flex",
        padding: 0.5,
        alignItems: "flex-start",
        gap: 1.25,
      }}
    >
      {buttonGroups.map((group, groupIndex) => (
        <Stack
          key={`world-map-button-group-${groupIndex}`}
          sx={{
            borderRadius: "4px",
            backgroundColor: neutral[0],
            overflow: "hidden",
          }}
        >
          {group.map((button, buttonIndex) => (
            <Tooltip
              key={`world-map-button-${groupIndex}-${buttonIndex}`}
              title={button.tooltip}
            >
              <Button
                onClick={button.isDisabled ? undefined : button.onClick}
                icon={button.icon}
                disabled={button.isDisabled}
                variant="ghost"
                sx={{
                  color: neutral[800],
                  padding: 0,
                  minWidth: "30px",
                  width: "30px",
                  height: "30px",
                  borderRadius: "unset",
                  backgroundColor: neutral[0],
                  "&:hover": {
                    backgroundColor: alpha(neutral[500], HOVER_OPACITY),
                  },
                  "&:active": {
                    backgroundColor: alpha(neutral[500], ACTIVE_OPACITY),
                  },
                }}
              >
                {""}
              </Button>
            </Tooltip>
          ))}
        </Stack>
      ))}
    </Stack>
  );
}
